module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-13.66620518.mp3";